<template>
  <!-- 按钮背景
       @author: liuguisheng
       @date: 2019-9-21
   -->
  <div class="setting-item">
    <el-form-item label="loading效果"> 
      <el-radio-group v-model="buttonLoading" size="small">
        <el-radio-button :label="false">无</el-radio-button>
        <el-radio-button :label="true">启用</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 按钮loading效果
     *  @description 将 buttonLoading 字段映射到当前 buttonLoading 计算属性
     *  @return {String}
     *  @author liuguisheng
     *  @version 2019-09-21
     */
    ...mapComputed({
      buttonLoading: { 
        parent: i => i.baseOption,
        attr: "buttonLoading" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingButtonLoading.vue